import api from '@utils/api';
import formutils from './formutils';
const addressutils = {
    saveAddress: async (values, formdef, onServerError, onSuccess) => {
        let errors = await formutils.validateForm(values, formdef, 'address');
        if (errors && Object.keys(errors).length > 0) {
            return errors;
        }
        return api
            .saveAddress(values, formdef)
            .then((data) => {
            if (data.error && data.error.length > 0) {
            }
            if (data.fields && Object.keys(data.fields).length > 0) {
                Object.keys(data.fields).forEach((f) => {
                    errors[f.substring(f.lastIndexOf('_') + 1, f.length)] = data.fields[f];
                });
                return errors;
            }
            onSuccess();
        })
            .catch((e) => onServerError(e));
    },
    salutation: (fistname, lastname, title) => {
        if (window.language == 'ja') {
            return `${lastname} ${fistname} 様`;
        }
        if (window.language == 'ch' || window.language == 'zh') {
            return `${lastname} ${fistname}${title || ''}`;
        }
        return `${title || ''} ${fistname} ${lastname}`;
    },
};
export default addressutils;
